import 'core-js/actual';
import 'regenerator-runtime/runtime';
import 'utils/Url';
import 'whatwg-fetch';
import runApplication from 'utils/framework/main';

runApplication();
